import httpClient from './httpClient';


const getFloatCashIn = (propertyId) => httpClient.get('/api/v2/ShiftWork/GetFloatCashIn', { params: { propertyId } });


const getShiftActive = (propertyId, userId) => httpClient.get('/api/v2/ShiftWork/getShiftActive', { params: { propertyId, userId } });

const getShiftView = (propertyId, shiftWorkId) => httpClient.get('/api/v2/ShiftWork/GetShiftView', { params: { propertyId, shiftWorkId } });

const getShiftCharges = (shiftWorkId) => httpClient.get('/api/v2/ShiftWork/GetShiftCharges', { params: { shiftWorkId } });

const getBookingPaymentItemListForShiftView = (shiftWorkId) => httpClient.get('/api/v2/ShiftWork/GetBookingPaymentItemListForShiftView', { params: {  shiftWorkId } });

const startShiftWork = (shiftStartDto) => httpClient.post('/api/v2/ShiftWork/StartShiftWork', shiftStartDto);

const shiftWorkChargeInput = (shiftStartDto) => httpClient.post('/api/v2/ShiftWork/ShiftWorkChargeInput', shiftStartDto);

const endShiftWork = (model) => httpClient.post('/api/v2/ShiftWork/EndShiftWork', model);


const ex = {
  getFloatCashIn,
  getShiftView,
  getShiftActive,
  getShiftCharges,
  getBookingPaymentItemListForShiftView,
  startShiftWork,
  endShiftWork,
  shiftWorkChargeInput,
}

export default ex;



// WEBPACK FOOTER //
// ./src/api/shift-work-api.js